<teleport to="body">
<div class="modal fade" id="edit_advert_modal" tabindex="-1" aria-labelledby="edit_advert_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs mb-0" id="edit_advert_label">
          Edit Advert
        </p>
        <button type="button" class="modal-btn-close btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body p-3">
        <div v-if="!editAdvertData || !editAdvertData.id" class="text-center py-5 text-muted">
          <p class="text-xxs">No advert selected</p>
        </div>
        <div v-else>
          <div class="mb-2 p-2 border rounded-3 bg-light">
            <button
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs w-100 d-flex justify-content-between align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#edit_advert_job_description_block"
              aria-expanded="false"
              aria-controls="edit_advert_job_description_block"
            >
              <span class="text-force-white"><i class="bi bi-file-earmark-text me-1 text-force-white"></i> Job Description</span>
              <i class="bi bi-chevron-down ms-auto text-force-white"></i>
            </button>

            <div id="edit_advert_job_description_block" class="collapse mt-2">
              <div v-if="!editAdvertData.job_profile_title && !editAdvertData.job_profile_description && (!editAdvertData.job_profile_sections || editAdvertData.job_profile_sections.length === 0)"
                   class="text-center text-muted py-2 text-xxs">
                No job description found for this job profile.
              </div>

              <div v-else class="border rounded-3 bg-white p-2 job-description-scroll">
                <p class="fw-bold text-xxs mb-1">{{ editAdvertData.job_profile_title || 'Job Description' }}</p>
                <div v-if="editAdvertData.job_profile_description" class="text-muted text-xxs mb-2 rich-content-view" v-html="advertCleanHtml(editAdvertData.job_profile_description)"></div>

                <div v-for="(section, idx) in (editAdvertData.job_profile_sections || [])" :key="'edit-jd-'+idx" class="mb-2 p-2 border rounded-3 bg-light">
                  <p class="fw-bold text-xxs mb-1">{{ section.title || ('Section ' + (idx + 1)) }}</p>

                  <div v-if="section.table && section.table.rows && section.table.rows.length > 0 && advertHasTableContent(section)" class="table-responsive mb-2">
                    <table class="table table-sm table-bordered align-middle mb-0">
                      <thead class="table-light">
                        <tr>
                          <th v-for="(hdr, hIdx) in section.table.headers" :key="'edit-jd-h-'+hIdx" class="text-xxs fw-semibold">
                            {{ typeof hdr === 'object' ? hdr.label : hdr }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, rIdx) in section.table.rows" :key="'edit-jd-r-'+rIdx">
                          <td v-for="(cell, cIdx) in row" :key="'edit-jd-c-'+cIdx" class="text-xxs" v-html="advertCleanHtml(cell)"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div v-else-if="section.descriptions && section.descriptions.length > 0">
                    <div v-for="(desc, dIdx) in section.descriptions" :key="'edit-jd-d-'+dIdx" class="text-xxs text-dark mb-1 rich-content-view" v-html="advertCleanHtml(desc)"></div>
                  </div>

                  <p v-else class="text-muted text-xxs mb-0 fst-italic">No content available for this section.</p>

                  <div v-if="section.subsections && section.subsections.length" class="mt-2 ps-3 border-start">
                    <div v-for="(subsection, subIdx) in section.subsections" :key="'edit-jd-sub-'+subIdx" v-show="subsection.show_on_advert !== false" class="mb-2 p-2 border rounded-3 bg-white">
                      <p class="fw-semibold text-xxs mb-1">{{ subsection.title || ('Sub-section ' + (subIdx + 1)) }}</p>

                      <div v-if="subsection.table && subsection.table.rows && subsection.table.rows.length > 0 && advertHasTableContent(subsection)" class="table-responsive mb-2">
                        <table class="table table-sm table-bordered align-middle mb-0">
                          <thead class="table-light">
                            <tr>
                              <th v-for="(hdr, hIdx) in subsection.table.headers" :key="'edit-jd-sub-h-'+hIdx" class="text-xxs fw-semibold">
                                {{ typeof hdr === 'object' ? hdr.label : hdr }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, rIdx) in subsection.table.rows" :key="'edit-jd-sub-r-'+rIdx">
                              <td v-for="(cell, cIdx) in row" :key="'edit-jd-sub-c-'+cIdx" class="text-xxs" v-html="advertCleanHtml(cell)"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div v-else-if="subsection.descriptions && subsection.descriptions.length > 0">
                        <div v-for="(desc, dIdx) in subsection.descriptions" :key="'edit-jd-sub-d-'+dIdx" class="text-xxs text-dark mb-1 rich-content-view" v-html="advertCleanHtml(desc)"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <p v-if="(editAdvertData.job_profile_sections || []).length === 0" class="text-muted text-xxs mb-0 fst-italic">No sections marked to show on advert.</p>
              </div>
            </div>
          </div>

          <div class="mb-3 p-3 border rounded-3 bg-light">
            <p class="fw-bold text-xs mb-2"><i class="bi bi-card-heading me-1"></i> Advert Details</p>

            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Advert Title</label>
                <input
                  v-model="editAdvertData.title"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="text"
                  placeholder="Enter advert title"
                />
              </div>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Reference Number</label>
                <input
                  v-model="editAdvertData.reference_number"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="text"
                  placeholder="e.g. REF-2025-001"
                />
              </div>
            </div>

            <div class="row g-2">
              <div class="col-md-3">
                <label class="form-label text-xxs fw-bold mb-1">Opening Date &amp; Time</label>
                <input
                  v-model="editAdvertData.published_date"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="datetime-local"
                  :min="editAdvertMinimumDateTime"
                />
              </div>
              <div class="col-md-3">
                <label class="form-label text-xxs fw-bold mb-1">Closing Date &amp; Time</label>
                <input
                  v-model="editAdvertData.closing_date"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="datetime-local"
                  :min="editAdvertClosingMinimumDateTime"
                />
              </div>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Vacancies</label>
                <input
                  v-model.number="editAdvertData.vacancies"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                  type="number"
                  min="0"
                  placeholder="Number of vacancies"
                />
              </div>
            </div>

            <div class="row g-2 mt-1">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-bold mb-1">Additional Details</label>
                <textarea
                  v-model="editAdvertData.details"
                  dir="ltr"
                  class="form-control form-control-sm text-xxs rounded-small shadow-sm rich-text-input"
                  @input="rebuildEditDisplayOrder"
                  rows="2"
                  placeholder="Any additional details for the advert..."
                ></textarea>
              </div>
            </div>
          </div>

          <div class="mb-3 p-3 border rounded-3 bg-light">
            <p class="fw-bold text-xs mb-2">Display Order</p>
            <small class="text-muted text-xxs d-block mb-2">Drag items using the grip on the right to set how users will see the advert.</small>
            <div v-if="editAdvertData.display_order && editAdvertData.display_order.length > 0">
              <div
                v-for="(item, idx) in editAdvertData.display_order"
                :key="item.key"
                class="d-flex justify-content-between align-items-center border rounded-3 p-2 mb-2 bg-white"
                draggable="true"
                @dragstart="onDisplayDragStart(idx)"
                @dragover.prevent
                @drop="onDisplayDrop(idx)"
                @dragend="onDisplayDragEnd"
              >
                <div>
                  <p class="mb-0 text-xxs fw-bold">
                    {{ item.source === 'details' ? 'Additional Information' :
                      item.source === 'profile' ? (editAdvertData.job_profile_sections[item.index]?.title || 'Job Description Section') :
                      (editAdvertData.sections[item.index]?.title || ('Advert Section ' + (item.index + 1))) }}
                  </p>
                  <small class="text-muted text-xxs">
                    {{ item.source === 'profile' ? 'Job Description' : item.source === 'details' ? 'Advert Details' : 'Advert Section' }}
                  </small>
                </div>
                <div class="d-flex align-items-center">
                  <span class="border rounded-small px-2 py-1 text-muted" title="Drag to reorder">
                    <i class="bi bi-grip-vertical"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 p-3 border rounded-3 bg-light">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="fw-bold text-xs mb-0">Advertisement Sections</p>
              <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="addAdvertSection">
                Add Section
              </button>
            </div>

            <div v-if="!editAdvertData.sections || editAdvertData.sections.length === 0" class="text-center py-3 text-muted">
              <p class="text-xxs">No sections added yet. Click "Add Section" to create one.</p>
            </div>

            <div v-for="(section, sidx) in (editAdvertData.sections || [])" :key="sidx" class="mb-3 p-2 border rounded-3 bg-white">
              <div class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <h6 class="fw-bold text-xxs mb-0">Section {{ sidx + 1 }}</h6>
                <div class="d-flex gap-1">
                  <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="removeAdvertSection(sidx)">
                    Remove
                  </button>
                </div>
              </div>

              <div class="row g-2">
                <div class="col-md-6">
                  <label class="form-label text-xxs fw-bold mb-1">Section Title</label>
                  <input
                    v-model="section.title"
                    class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                    type="text"
                    placeholder="e.g. Benefits, Requirements"
                  />
                </div>

                <div class="col-md-6">
                  <label class="form-label text-xxs fw-bold mb-1">Content Type</label>
                  <select v-model="section.type" class="form-select form-select-sm text-xxs rounded-small shadow-sm">
                    <option value="text">Text</option>
                    <option value="table">Table</option>
                  </select>
                </div>
              </div>

              <div v-if="sectionHasSubsections(section)" class="row g-2 mt-1">
                <div class="col-12">
                  <div class="alert alert-light border text-xxs mb-0">
                    Section content is hidden while this section uses sub-sections.
                  </div>
                </div>
              </div>

              <div v-else-if="section.type === 'text'" class="row g-2 mt-1">
                <div class="col-12">
                  <label class="form-label text-xxs fw-bold mb-1">Content</label>
                  <div class="d-flex flex-wrap gap-1 mb-2">
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('bold')"><i class="bi bi-type-bold text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('italic')"><i class="bi bi-type-italic text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('underline')"><i class="bi bi-type-underline text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('insertUnorderedList')"><i class="bi bi-list-ul text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyLeft')"><i class="bi bi-text-left text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyCenter')"><i class="bi bi-text-center text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyRight')"><i class="bi bi-text-right text-force-white"></i></button>
                  </div>
                  <div
                    class="form-control form-control-sm text-xxs rounded-small shadow-sm rich-editor-content"
                    contenteditable="true"
                    dir="ltr"
                    @focus="setActiveRichEditor($event)"
                    @blur="section.content = $event.target.innerHTML"
                    v-html="section.content || ''"
                  ></div>
                </div>
              </div>

              <div v-else-if="section.type === 'table'" class="row g-2 mt-2">
                <div class="col-12">
                  <label class="form-label text-xxs fw-bold mb-1">Table Headers</label>
                  <div class="d-flex flex-column gap-2 mb-2">
                    <div v-for="(hdr, hidx) in (section.table && section.table.headers || [])" :key="'h-'+hidx" class="d-flex gap-2 align-items-center">
                      <input
                        v-model="section.table.headers[hidx]"
                        type="text"
                        class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                        placeholder="Header name"
                      />
                      <button class="btn btn-outline-danger btn-sm rounded-small text-xxs" type="button" @click="removeAdvertTableHeader(section.table, hidx)">Remove</button>
                    </div>
                    <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs align-self-start" type="button" @click="addAdvertTableHeader(section.table)">+</button>
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label text-xxs fw-bold mb-1">Table Rows</label>
                  <div class="d-flex flex-wrap gap-1 mb-2">
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('bold')"><i class="bi bi-type-bold text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('italic')"><i class="bi bi-type-italic text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('underline')"><i class="bi bi-type-underline text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('insertUnorderedList')"><i class="bi bi-list-ul text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyLeft')"><i class="bi bi-text-left text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyCenter')"><i class="bi bi-text-center text-force-white"></i></button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs text-force-white" @click="applyRichTextCommand('justifyRight')"><i class="bi bi-text-right text-force-white"></i></button>
                  </div>
                  <div v-for="(row, ridx) in (section.table && section.table.rows || [])" :key="'r-'+ridx" class="d-flex gap-2 mb-2">
                    <div
                      v-for="(cell, cidx) in row"
                      :key="'c-'+cidx"
                      class="form-control form-control-sm text-xxs rounded-small shadow-sm flex-grow-1 rich-editor-cell"
                      contenteditable="true"
                      dir="ltr"
                      @focus="setActiveRichEditor($event)"
                      @blur="section.table.rows[ridx][cidx] = $event.target.innerHTML"
                      v-html="section.table.rows[ridx][cidx] || ''"
                    ></div>
                    <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="section.table.rows.splice(ridx, 1)">Delete</button>
                  </div>
                  <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs w-100 mt-2" type="button"
                          @click="addAdvertTableRow(section.table)">
                    Add Row
                  </button>
                </div>
              </div>

              <div class="mt-3 pt-3 border-top">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <p class="fw-bold text-xxs mb-0">Sub-sections</p>
                  <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="addAdvertSubsection(sidx)">
                    Add Sub-section
                  </button>
                </div>

                <div v-if="!section.subsections || section.subsections.length === 0" class="text-muted text-xxs fst-italic">
                  No sub-sections added yet.
                </div>

                <div v-for="(subsection, subIdx) in (section.subsections || [])" :key="'e-sub-'+sidx+'-'+subIdx" class="mb-3 p-2 border rounded-3 bg-light">
                  <div class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                    <h6 class="fw-bold text-xxs mb-0">Sub-section {{ subIdx + 1 }}</h6>
                    <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="removeAdvertSubsection(sidx, subIdx)">
                      Remove
                    </button>
                  </div>

                  <div class="row g-2">
                    <div class="col-md-6">
                      <label class="form-label text-xxs fw-bold mb-1">Sub-section Title</label>
                      <input
                        v-model="subsection.title"
                        class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                        type="text"
                        placeholder="e.g. Technical Skills"
                      />
                    </div>

                    <div class="col-md-6">
                      <label class="form-label text-xxs fw-bold mb-1">Content Type</label>
                      <select v-model="subsection.type" class="form-select form-select-sm text-xxs rounded-small shadow-sm">
                        <option value="text">Text</option>
                        <option value="table">Table</option>
                      </select>
                    </div>
                  </div>

                  <div v-if="subsection.type === 'text'" class="row g-2 mt-1">
                    <div class="col-12">
                      <label class="form-label text-xxs fw-bold mb-1">Content</label>
                      <div
                        class="form-control form-control-sm text-xxs rounded-small shadow-sm rich-editor-content"
                        contenteditable="true"
                        dir="ltr"
                        @focus="setActiveRichEditor($event)"
                        @blur="subsection.content = $event.target.innerHTML"
                        v-html="subsection.content || ''"
                      ></div>
                    </div>
                  </div>

                  <div v-else-if="subsection.type === 'table'" class="row g-2 mt-2">
                    <div class="col-12">
                      <label class="form-label text-xxs fw-bold mb-1">Table Headers</label>
                      <div class="d-flex flex-column gap-2 mb-2">
                        <div v-for="(hdr, hidx) in (subsection.table && subsection.table.headers || [])" :key="'es-h-'+hidx" class="d-flex gap-2 align-items-center">
                          <input
                            v-model="subsection.table.headers[hidx]"
                            type="text"
                            class="form-control form-control-sm text-xxs rounded-small shadow-sm"
                            placeholder="Header name"
                          />
                          <button class="btn btn-outline-danger btn-sm rounded-small text-xxs" type="button" @click="removeAdvertTableHeader(subsection.table, hidx)">Remove</button>
                        </div>
                        <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs align-self-start" type="button" @click="addAdvertTableHeader(subsection.table)">+</button>
                      </div>
                    </div>

                    <div class="col-12">
                      <label class="form-label text-xxs fw-bold mb-1">Table Rows</label>
                      <div v-for="(row, ridx) in (subsection.table && subsection.table.rows || [])" :key="'es-r-'+ridx" class="d-flex gap-2 mb-2">
                        <div
                          v-for="(cell, cidx) in row"
                          :key="'es-c-'+cidx"
                          class="form-control form-control-sm text-xxs rounded-small shadow-sm flex-grow-1 rich-editor-cell"
                          contenteditable="true"
                          dir="ltr"
                          @focus="setActiveRichEditor($event)"
                          @blur="subsection.table.rows[ridx][cidx] = $event.target.innerHTML"
                          v-html="subsection.table.rows[ridx][cidx] || ''"
                        ></div>
                        <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" @click="subsection.table.rows.splice(ridx, 1)">Delete</button>
                      </div>
                      <button class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs w-100 mt-2" type="button"
                              @click="addAdvertTableRow(subsection.table)">
                        Add Row
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer border-top p-2 d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small shadow text-xxs" :disabled="advertSaving" @click="emitUpdateAdvert">
          {{ advertSaving ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>

    </div>
  </div>
</div>
</teleport>
